// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"Loader_textWrapper__4xl5y","text":"Loader_text__apuW_"};